// src/pages/About.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const About = () => {
  return (
    <>
      <Helmet>
        <title>Students | Project V.O.T.E.</title>
      </Helmet>
      <div className="mx-auto max-w-7xl sm:px-4 md:px-6 lg:px-8 h-full">
        {/* Header Section */}
        <div className="relative rounded-t-lg bg-stone-100 py-8 sm:py-16 lg:py-24">
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row lg:items-center">
              <div className="lg:flex-1">
                <h1 className="mt-1 text-4xl font-extrabold sm:text-5xl lg:text-6xl">
                  Student Activities
                </h1>
                <p className="max-w-xl mt-5 text-xl text-gray-900">
                  Welcome to the Project V.O.T.E. Student Activities page! Here, you can learn about voting and elections through fun and interactive games. Get ready to become a voting expert while having a great time!        </p>
              </div>
              <div className="mt-8 lg:mt-0 lg:ml-8 lg:flex-shrink-0">
                <img
                  src={`${process.env.PUBLIC_URL}/images/pencils.webp`}
                  alt="Brightly colored pencils arranged diagonally."
                  className="w-[400px] h-[300px]"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="mx-auto max-w-7xl bg-white p-3">
          <Link to="../cardgame">
            <div className="mb-8 md:flex">
              <div className="md:w-1/3">
                <img src="images/students/matching-game.png" className="w-full h-auto" alt="Terminology Quiz" />
              </div>
              <div className="md:w-2/3 md:pl-4 mt-4 md:mt-0">
                <h2 className="text-xl font-semibold mb-2">Matching Game</h2>
                <p>Test your memory by matching pairs of voting-related images. Click on the cards to flip them and find matching pairs!</p>
              </div>
            </div>
          </Link>

          <Link to="../electoralgame">
            <div className="mb-8 md:flex">
              <div className="md:w-1/3">
                <img src="images/students/usmap_outlines.png" className="w-full h-auto" alt="Interactive Electoral College Map" />
              </div>
              <div className="md:w-2/3 md:pl-4 mt-4 md:mt-0">
                <h2 className="text-xl font-semibold mb-2">Interactive Electoral College Map</h2>
                <p>Explore the Interactive Electoral College Map and discover how the U.S. presidential elections work! Click on different states to learn how many electoral votes they have and see how they contribute to the total needed to win the presidency. This game will help you understand the importance of each state's votes in the election process.</p>
              </div>
            </div>
          </Link>

          <Link to="../wordsearch">
            <div className="mb-8 md:flex">
              <div className="md:w-1/3">
                <img src="images/students/word-search.png" className="w-full h-auto" alt="Election word search" />
              </div>
              <div className="md:w-2/3 md:pl-4 mt-4 md:mt-0">
                <h2 className="text-xl font-semibold mb-2">Word Search</h2>
                <p>Explore the language of elections in our interactive word search. See if you have what it takes to find them all!</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default About;

